export enum IReinvestmentStrategy {
  NOT_ALLOWED = 'NOT_ALLOWED',
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC'
}
